<template>
    <div class="head">
        <div class="header">
            <div class="nav-wrap " :class="{ 'fix-nav': top > 50 }">
                <el-row class="wrapper w1200">
                    <div class="left-wrap">
                        <router-link to="/index" class="logo">海南光年之旅科技有限公司</router-link>
                    </div>
                    <el-row>
                        <router-link :to="{ path: '/about', query: { id: 47 } }" class="link-btn"><span>商家入驻</span></router-link>
                        <router-link to="/shoplist" class="link-btn"><span>合作商家</span></router-link>
                        <router-link to="" class="link-btn"><span @click="$y_msg('请先登录')">商家管理</span></router-link>
                        <router-link to="/shopinfo" class="link-btn"><span>信息发布</span></router-link>
                        <router-link to="" class="link-btn" v-if="!s_getUser"><span @click="showLoginModal()">注册/登录</span></router-link>
                    </el-row>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        province,
        city
    } from "@utils/area";
    import {
        mapGetters,
        mapMutations
    } from "vuex";
    export default {
        name: "myHeader",
        components: {},
        data() {
            // 这里存放数据
            return {
                logined: true,
                top: 0,
                config: {}, // 配置
            };
        },
        mounted() {
            let _this = this;
            this.config = this.$y_getKey("config");
            _this.$nextTick(function() {
                // 根据滚动高度显示头部
                window.onscroll = function(e) {
                    _this.top = document.documentElement.scrollTop;
                };
            });
        },
        // 监听属性 类似于data概念
        computed: {
            ...mapGetters(["s_getUser"]),
        },
        // 方法集合
        methods: {
            ...mapMutations(["s_setUser", "s_setLoginModal", "s_setCity"]),

            showLoginModal() {
                this.s_setLoginModal(1);
            },
            // 选择省份
            setProvice(index) {
                this.cityIndex = index;
                this.tags = "2";
            },
            // 选择城市
            setCity(m, index) {
                if (m == "全国") {
                    m = "";
                }
                m = m.replace("市", "");
                this.cityInfo.val = m;
                this.cityInfo.show = false;
                this.s_setCity({
                    proIndex: this.cityIndex,
                    city: m,
                });
            },
            // 退出登录
            async logout() {
                let t = Math.ceil(new Date().getTime() / 1000);
                await this.$y_ajax("api/login/setOnline", {
                    state: 0,
                    user_id: this.$y_getKey("userid"),
                    logout: t,
                });
                this.$y_rmKey("userid");
                this.$y_rmKey("token");
                this.s_setUser("");
            },
        },
        watch: {},
    };
</script>
<style scoped lang="less">
    // 一级导航
    .header {
        position: relative;
        z-index: 3;
        background: #fff;

        // 顶部小指引
        .top-wrap {
            background: #f5f5f5;
            text-align: right;

            .city-btn {
                float: left;
            }

            .el-icon-search {
                padding: 10px;
                display: inline-block;
                font-size: 20px;
                cursor: pointer;
            }

        }

        .nav-wrap {
            border-bottom: 1px solid #eee;

            &.fix-nav {
                position: fixed;
                width: 100%;
                background: #fff;
                box-shadow: 0 2px 5px #ddd;
                border-bottom: 0;
                top: 0;
            }

            .link-btn {
                padding: 10px;
                display: inline-block;
            }
        }

        //分类栏
        .wrapper {
            display: flex;
            align-items: center;

            .left-wrap {
                display: flex;
                flex: 1;
                line-height: 70px;
            }

            .logo {
                display: inline-block;
                height: 70px;
                display: flex;
                align-items: center;
                margin-right: 20px;
                font-size: 20px;
                font-weight: bold;

                img {
                    height: 60%;
                    border-radius: 7px;
                }
            }

            // 大导航
            .nav {
                border: 0;
                font-size: 0;

                li {
                    display: inline-block;
                    padding: 0;
                    color: #909399;
                    cursor: pointer;
                    border-bottom: 2px solid transparent;
                }

                .is-active {
                    color: #cd7dfe;
                    font-weight: bold;
                }

                span {
                    padding: 0 30px;
                    display: block;
                    font-size: 18px;
                    text-align: center;
                    text-decoration: none;
                }
            }

            .app-btn {
                background: #cd7dfe;
                border: 0;
                color: #fff;
            }
        }
    }

    .city-box {
        width: 400px;
    }

    .city {
        .name {
            margin-right: 15px;
            margin-bottom: 15px;
            display: inline-block;
            cursor: pointer;

            &:hover {
                color: #cd7dfe;
            }

            &.active {
                color: #cd7dfe;
            }
        }
    }

    .nopc-app {
        display: none !important;
    }

    /* 移动端 */
    @media (max-width: 600px) {
        .logo {
            display: none !important;
        }

        .app-btn {
            margin-right: 15px;
        }

        .nopc-app {
            float: left;
            display: inline-block !important;
        }

        .header .wrapper {
            display: block;

            .nav {
                display: -webkit-box;
                overflow-x: auto;
                width: 100%;
                line-height: 40px;

                span {
                    width: auto;
                    padding: 0 10px;
                }
            }

            .app-btn {
                display: none;
            }
        }
    }
</style>